// @flow
// This is mainly because we want to avoid frequent subscribe/unsubscribe as WC updating itself.
// In an extreme case(~100ms in between refresh), the timing shift can make the interval impossible to fire.
// Not a common scenario in our use case but still useful to save some unnecessary update.
// Based on https://overreacted.io/making-setinterval-declarative-with-react-hooks/

import { useEffect, useRef } from 'react';

export default function useInterval(callback: any, delay: ?number) {
  const savedCallback = useRef();

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    function tick() {
      if (typeof savedCallback.current === 'function') {
        savedCallback.current();
      }
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
